/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/search')) return;

  var params = new URLSearchParams(window.location.search);
  var searchTerm = (params.get('q') || '').trim();
  if (!searchTerm) return;

  // Solo en referencias numéricas (5+ dígitos), p. ej. 4472102
  if (!/^\d{5,}$/.test(searchTerm)) return;

  var loop = document.querySelector('#SearchLoop');
  if (!loop) return;

  function norm(v) {
    return String(v || '')
      .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[_-]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function expandReferenceResults() {
    var cards = Array.prototype.slice.call(loop.querySelectorAll('.product-item'));
    if (!cards.length) return false;

    var fragment = document.createDocumentFragment();
    var total = 0;
    var seenProducts = {};

    cards.forEach(function (card) {
      var cell = card.closest('#SearchLoop > *') || card;

      // Evitar expandir el mismo producto dos veces (Shopify lo repite por variante)
      var idMatch = (card.id || '').match(/(\d{6,})$/);
      var pid = idMatch ? idMatch[1] : ((card.querySelector('a[href*="/products/"]') || {}).href || Math.random());
      if (seenProducts[pid]) return;
      seenProducts[pid] = true;

      // Imágenes del producto (todas las de todos los colores)
      var jsonEl = card.querySelector('.jvz-product-images-json');
      var images = [];
      if (jsonEl) { try { images = JSON.parse(jsonEl.textContent || '[]'); } catch (e) { images = []; } }

      // Colores disponibles (valor + enlace a su variante)
      var seenColor = {};
      var colors = [];
      Array.prototype.slice.call(card.querySelectorAll('.color-radio-input')).forEach(function (r) {
        var v = r.value;
        if (!v || seenColor[norm(v)]) return;
        seenColor[norm(v)] = true;
        colors.push({ value: v, url: r.getAttribute('data-variant-url') || '' });
      });

      // Sin opción de color con varios valores: dejar la tarjeta tal cual
      if (colors.length <= 1) { fragment.appendChild(cell.cloneNode(true)); total++; return; }

      function coverFor(colorVal) {
        var c = norm(colorVal);
        for (var i = 0; i < images.length; i++) {
          var f = norm((images[i].src || '') + ' ' + (images[i].search || ''));
          if (f.indexOf(c) > -1) return images[i];
        }
        return null;
      }

      // Una tarjeta por color
      colors.forEach(function (col, idx) {
        var clone = cell.cloneNode(true);
        var pi = clone.matches('.product-item') ? clone : clone.querySelector('.product-item');
        if (!pi) return;

        // Radios: nombre único por tarjeta + marcar SOLO el color de esta tarjeta
        Array.prototype.slice.call(clone.querySelectorAll('.color-radio-input')).forEach(function (r) {
          r.name = 'color-ref-' + pid + '-' + idx;
          if (norm(r.value) === norm(col.value)) { r.checked = true; r.setAttribute('checked', ''); }
          else { r.checked = false; r.removeAttribute('checked'); }
        });
        pi.dataset.jvzManualColorSelected = 'true';
        pi.classList.add('jvz-search-reference-card');

        // Portada del color (primera imagen cuyo nombre contiene el color)
        var cov = coverFor(col.value);
        if (cov) {
          var u = cov.srcMedium || cov.src || cov.srcSmall;
          var im = clone.querySelector('[data-product-image-default] img') || clone.querySelector('.product-item__image img');
          if (im && u) {
            im.setAttribute('src', u);
            im.setAttribute('data-jvz-active-image', u);
            im.setAttribute('data-original-src', u);
            if (im.hasAttribute('srcset')) im.setAttribute('srcset', u);
            if (im.hasAttribute('data-srcset')) im.setAttribute('data-srcset', u);
            // Que la imagen rellene la caja (evita que se renderice recortada a su alto nativo)
            im.style.position = 'absolute';
            im.style.top = '0';
            im.style.left = '0';
            im.style.width = '100%';
            im.style.height = '100%';
            im.style.objectFit = 'cover';
          }
        }

        // Enlaces a la variante de ese color
        if (col.url) {
          Array.prototype.slice.call(clone.querySelectorAll('a[href*="/products/"]')).forEach(function (a) {
            a.setAttribute('href', col.url);
          });
        }

        // Añadir el color al título (como en el predictivo)
        var te = clone.querySelector('.product-item__title');
        if (te && te.textContent.toLowerCase().indexOf(col.value.toLowerCase()) === -1) {
          te.textContent = te.textContent.trim() + ' - ' + col.value;
        }

        fragment.appendChild(clone);
        total++;
      });
    });

    if (!total) return false;

    loop.innerHTML = '';
    loop.appendChild(fragment);

    // Reinicializar el slider para que respete el color de cada tarjeta
    if (window.JVZCollectionImageSlideV2 && typeof window.JVZCollectionImageSlideV2.init === 'function') {
      loop.querySelectorAll('.product-item').forEach(function (c) { delete c.dataset.jvzImageSlideReady; });
      window.JVZCollectionImageSlideV2.init();
    }
    return true;
  }

  // El servidor a veces tarda en pintar la rejilla: reintentar un par de veces
  if (!expandReferenceResults()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (expandReferenceResults() || tries >= 6) clearInterval(iv);
    }, 400);
  }
});

(function () {
  var styleId = 'jvz-search-reference-hover-fix';
  if (document.getElementById(styleId)) return;

  var style = document.createElement('style');
  style.id = styleId;
  style.innerHTML = [
    /* Ocultar imagen de hover (evita que aparezca otro color al pasar el ratón) */
    '.jvz-search-reference-card .product-item__bg__under,',
    '.jvz-search-reference-card .product-item__bg__under.deferred-media,',
    '.jvz-search-reference-card [data-product-image-hover] {',
    '  display: none !important;',
    '  opacity: 0 !important;',
    '  visibility: hidden !important;',
    '}',
    /* Forzar que la imagen rellene su caja (evita el recorte a su alto nativo) */
    '.jvz-search-reference-card .product-item__image img:not(.jvz-image-slide-frame) {',
    '  position: absolute !important;',
    '  top: 0 !important;',
    '  left: 0 !important;',
    '  width: 100% !important;',
    '  height: 100% !important;',
    '  object-fit: cover !important;',
    '}'
  ].join('\n');

  document.head.appendChild(style);
})();

/* ============================================================
   JVZ · Móvil (SOLO B2C) — Seleccionar talla = añadir al carrito
   ============================================================ */
(function () {
  var MOBILE_QUERY = '(max-width: 767px)';
  var SIZE_WRAPPER = '.size-selector-wrapper, .selector-wrapper--size';
  var EXCLUDE =
    '.product-quick-add, .product-quick-add__form, quick-add-modal, ' +
    '.quick-add-form, #b2b-bulk-modal, .b2b-bulk-modal, .b2b-modal-wrap';
  var UNAVAILABLE_MSG = 'Talla no disponible';

  function isB2b()    { return window.jvzIsB2b === true; }
  function isMobile() { return window.matchMedia(MOBILE_QUERY).matches; }

  function getForm(el) {
    if (el.form) return el.form;
    var byAttr = el.getAttribute && el.getAttribute('form');
    if (byAttr) { var f = document.getElementById(byAttr); if (f) return f; }
    return el.closest ? el.closest('form') : null;
  }

  function inputIsUnavailable(input) {
    if (!input) return true;
    return input.disabled ||
           input.classList.contains('sold-out') ||
           input.classList.contains('unavailable');
  }

  function scoped(el) {
    return el && el.closest && el.closest(SIZE_WRAPPER) && !el.closest(EXCLUDE);
  }

  function resolveInput(label) {
    var forId = label.getAttribute('for');
    return forId ? document.getElementById(forId)
                 : label.parentNode.querySelector('input[type="radio"]');
  }

  var toastEl = null, toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.style.cssText = [
        'position:fixed','left:50%','bottom:88px',
        'transform:translateX(-50%) translateY(10px)','white-space:nowrap',
        'z-index:2147483000','background:#111','color:#fff','padding:12px 16px',
        'border-radius:8px','font-size:14px','line-height:1.3','text-align:center',
        'box-shadow:0 4px 16px rgba(0,0,0,.25)','opacity:0','pointer-events:none',
        'transition:opacity .2s ease, transform .2s ease'
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    void toastEl.offsetWidth;
    toastEl.style.opacity = '1';
    toastEl.style.transform = 'translateX(-50%) translateY(0)';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translateX(-50%) translateY(10px)';
    }, 1500);
  }

  function tryAddToCart(form) {
    if (!form || form.__jvzAutoAddBusy) return;
    form.__jvzAutoAddBusy = true;
    var start = Date.now(), MAX_WAIT = 1000;
    var poll = setInterval(function () {
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn && !btn.disabled && !btn.hasAttribute('disabled')) {
        clearInterval(poll);
        btn.click();
        setTimeout(function () { form.__jvzAutoAddBusy = false; }, 1000);
        return;
      }
      if (Date.now() - start >= MAX_WAIT) {
        clearInterval(poll);
        form.__jvzAutoAddBusy = false;
        showToast(UNAVAILABLE_MSG);
      }
    }, 60);
  }

  // 1) CAPTURA: bloquea la talla agotada, evita el cierre y avisa
  document.addEventListener('click', function (e) {
    if (isB2b() || !isMobile()) return;
    var label = e.target.closest ? e.target.closest('label') : null;
    if (!label || !scoped(label)) return;
    var input = resolveInput(label);
    if (!input || !input.matches('[data-single-option-selector]')) return;
    if (inputIsUnavailable(input)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showToast(UNAVAILABLE_MSG);
    }
  }, true);

  // 2) Talla disponible -> añadir (también si ya estaba seleccionada, p.ej. XXS)
  document.addEventListener('click', function (e) {
    if (isB2b() || !isMobile() || !e.isTrusted) return;
    var label = e.target.closest ? e.target.closest('label') : null;
    if (!label || !scoped(label)) return;
    var input = resolveInput(label);
    if (!input || !input.matches('[data-single-option-selector]')) return;
    if (inputIsUnavailable(input)) return; // ya bloqueada en captura
    tryAddToCart(getForm(input));
  });

  // 3) Popout-select (desplegable)
  document.addEventListener('click', function (e) {
    if (isB2b() || !isMobile()) return;
    var opt = e.target.closest ? e.target.closest('[data-popout-option]') : null;
    if (!opt || !scoped(opt)) return;
    tryAddToCart(getForm(opt));
  });
})();

/* ============================================================
   JVZ · Aviso "Producto añadido" bajo su línea (empuja y colapsa)
   ============================================================ */
(function () {
  var ENTER_DELAY = 300;  // espera a que el drawer abra
  var HIDE_MS = 3000;     // duración visible
  var FADE_MS = 400;      // colapso/atenuado de salida
  var MSG = 'Producto añadido correctamente';

  var pendingKey = null, enterAt = 0, hideAt = 0, removeAt = 0, ticker = null;

  function buildMsg() {
    var wrap = document.createElement('div');
    wrap.className = 'jvz-cart-added';
    wrap.setAttribute('data-jvz-cart-added', '');
    var inner = document.createElement('div');
    inner.className = 'jvz-cart-added__inner';
    var box = document.createElement('div');
    box.className = 'jvz-cart-added__box';
    box.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      MSG;
    inner.appendChild(box);
    wrap.appendChild(inner);
    return wrap;
  }

  function findLine() {
    var line = null;
    if (pendingKey) {
      var sel = (window.CSS && CSS.escape) ? CSS.escape(pendingKey) : pendingKey;
      line = document.querySelector('.cart__item[data-item="' + sel + '"]');
    }
    if (!line) {
      var items = document.querySelectorAll('.cart__item');
      line = items.length ? items[items.length - 1] : null;
    }
    return line;
  }

  function currentMsg() { return document.querySelector('[data-jvz-cart-added]'); }

  function place() {
    var line = findLine();
    if (!line) return null;
    var msg = currentMsg();
    if (msg && msg.previousElementSibling === line) return msg;
    if (msg) msg.remove();
    msg = buildMsg();
    line.insertAdjacentElement('afterend', msg);
    void msg.offsetWidth; // reflow para permitir la transición
    return msg;
  }

  function cleanup() { var m = currentMsg(); if (m) m.remove(); }

  function tick() {
    var now = Date.now();
    if (now >= removeAt) { clearInterval(ticker); ticker = null; cleanup(); return; }
    if (now >= hideAt) { var m = currentMsg(); if (m) m.classList.remove('is-visible'); return; }
    var msg = place();
    if (msg && now >= enterAt) msg.classList.add('is-visible');
  }

  function trigger(key) {
    pendingKey = key || null;
    var now = Date.now();
    enterAt = now + ENTER_DELAY;
    hideAt = enterAt + HIDE_MS;
    removeAt = hideAt + FADE_MS;
    place();
    if (ticker) clearInterval(ticker);
    ticker = setInterval(tick, 80);
    tick();
  }

  function isAddUrl(u) {
    return typeof u === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(u);
  }
  function extractKey(data) {
    if (!data) return null;
    if (data.key) return data.key;
    if (data.items && data.items.length) return data.items[data.items.length - 1].key;
    return null;
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var p = origFetch.apply(this, arguments);
      if (isAddUrl(url)) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          r.clone().json()
            .then(function (data) { trigger(extractKey(data)); })
            .catch(function () { trigger(null); });
        }).catch(function () {});
      }
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.__jvzIsAdd = isAddUrl(url);
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__jvzIsAdd) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        var key = null;
        try { key = extractKey(JSON.parse(this.responseText)); } catch (e) {}
        trigger(key);
      });
    }
    return origSend.apply(this, arguments);
  };
})();

/* ============================================================
   JVZ · "Seguir comprando" cierra el drawer (no va a la home)
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.cart__view') : null;
    if (!link) return;
    // solo si el botón está dentro del drawer del carrito
    if (!link.closest('#cart-drawer, [data-cart-drawer]')) return;

    e.preventDefault();
    var closeBtn = document.querySelector('#cart-drawer [data-cart-drawer-close], [data-cart-drawer] [data-cart-drawer-close]');
    if (closeBtn) {
      closeBtn.click();
    } else {
      // respaldo: quitar la clase que mantiene el drawer abierto
      var drawer = document.querySelector('#cart-drawer, [data-cart-drawer]');
      if (drawer) drawer.classList.remove('is-open', 'drawer--cart-is-open');
    }
  }, true);
})();